import React, { useEffect } from "react";
import MemberRegistrationForm from "../../components/client/MemberRegistrationForm";
import {
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
  HomeIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
function Contact() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">Liên hệ</span>
            </div>
          </li>
        </ol>
      </nav>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-3 mb-2">
        <div className=" rounded-lg">
          <div className=" bg-base-100  mx-auto">
            <div className="card-body p-0">
              <h1 className="text-3xl font-bold text-primary mb-4 flex justify-center items-center ">
                Liên hệ với chúng tôi
              </h1>

              <p className="text-base-content opacity-70 mb-6">
                Mọi thông tin chi tiết & nhận tư vấn cụ thể hơn xin quý khách
                vui lòng liên hệ trực tiếp:
              </p>

              <h2 className="text-2xl font-bold text-primary mb-4">
                CLB doanh nhân đồng hương Bạc Liêu - Cà Mau tại Cần Thơ
              </h2>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPinIcon className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                  <div>
                    <span className="font-medium">Địa chỉ:</span>
                    <span className="text-base-content ml-2">
                      Số 52, Đường B12, KDC Hưng Phú 1, Q. Cái Răng, Tp. Cần Thơ
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <PhoneIcon className="w-6 h-6 text-primary flex-shrink-0" />
                  <div>
                    <span className="font-medium">Điện thoại:</span>
                    <a href="tel:0939168552" className="link link-primary ml-1">
                      0939 168 552
                    </a>{" "}
                    ( Hồ Chí Hiệp - Trưởng ban thành viên)
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <PhoneIcon className="w-6 h-6 text-primary flex-shrink-0" />
                  <div>
                    <span className="font-medium">Hotline:</span>
                    <a href="tel:0915776663" className="link link-primary ml-1">
                      0915 776 663
                    </a>{" "}
                    ( Trang Tuấn Kiệt - Chủ tịch)
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <EnvelopeIcon className="w-6 h-6 text-primary flex-shrink-0" />
                  <div>
                    <span className="font-medium">Email:</span>
                    <a
                      href="mailto:trangtuankiet@gmail.com"
                      className="link link-primary ml-1"
                    >
                      trangtuankiet@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" rounded-lg">
          <div className=" bg-base-100  flex justify-center items-center  mx-auto">
            <div className="card-body p-0 mt-5">
              <h1 className="text-3xl font-bold text-primary mb-4 flex justify-center items-center ">
                Đăng ký hội viên
              </h1>
              <MemberRegistrationForm useId={false} />
            </div>
          </div>
        </div>
      </div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d435.0004633541015!2d105.78858562903172!3d10.017736395738906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0628469906aff%3A0x5107ae5cb4f8ff50!2zNTIgxJDGsOG7nW5nIEIxMiwgS0RDIEjGsG5nIFBow7ogMSwgQ8OhaSBSxINuZywgQ-G6p24gVGjGoSwgVmnhu4d0IE5hbQ!5e1!3m2!1svi!2s!4v1740561447911!5m2!1svi!2s"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        title="gg Map"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}

export default Contact;
